import { all } from 'redux-saga/effects'

import callNotificationSaga from './callNotificationSaga'

function* callNotificationSagas() {
  yield all([callNotificationSaga()])
}

export default callNotificationSagas
